import React from "react";
import { Box, CircularProgress } from "@mui/material";

const LoadingIndicator = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      p: 2,
    }}
  >
    <CircularProgress size={60} />
  </Box>
);

export default LoadingIndicator;
